<template>
  <section class="form-underwriting width-700">
    <el-form
      ref="form"
      :rules="rules"
      class="form-container"
      :model="formData">
      <div class="form-item">
        <span>Occupancy</span>
        <el-form-item
          prop="prop_insured">
          <v-select
            v-model="formData.prop_insured"
            :list="localAllOptions.prop_insured" />
        </el-form-item>
      </div>
      <div class="form-item">
        <span> Type of Building </span>
        <el-form-item
          ref="bldg_typ"
          prop="bldg_typ">
          <v-select
            v-model="formData.bldg_typ"
            :list="localAllOptions.bldg_types" />
        </el-form-item>
      </div>
      <div class="form-item">
        <span>Gross Floor Area (Indoor & Outdoor)</span>
        <el-form-item
          ref="floor_area"
          prop="floor_area">
          <v-input
            v-model="formData.floor_area"
            maxlength="8"
            append="sq. ft."
          />
        </el-form-item>
      </div>
      <div class="form-item">
        <span>Coverage</span>
        <el-form-item
          ref="coverage"
          prop="coverage">
          <v-select
            v-model="formData.coverage_id"
            :list="localAllOptions.coverage" />
        </el-form-item>
      </div>
      <div
        v-if="hasSumBuildingStructure"
        class="form-item">
        <span>Sum Insured of Building Structure</span>
        <el-form-item
          ref="bsc_sum_insured"
          prop="bsc_sum_insured">
          <v-input
            v-model="formData.bsc_sum_insured"
            :int="true"
            :keyNumber="true"
            prepend="HK$" />
        </el-form-item>
      </div>
      <div class="form-item">
        <span>Property Age</span>
        <el-form-item
          ref="prop_age"
          prop="prop_age">
          <v-select
            v-model="formData.prop_age"
            :list="localAllOptions.prop_age" />
        </el-form-item>
      </div>
      <!-- <div class="form-item">
        <span>Plan Level</span>
        <el-form-item
          prop="plan_tier"
        >
          <v-radio-group
            v-model="formData.plan_tier"
            :border="true"
            :list="planLevelOptions"
          />
        </el-form-item>
      </div> -->
      <!-- <div class="form-item">
        <span>Sum Insured</span>
        <el-form-item
          prop="sum_owner_liability">
          <v-input
            v-model="formData.sum_owner_liability"
            append="HKD" />
        </el-form-item>
      </div> -->
      <!-- 刪除 2020-09-03 -->
      <!-- <div class="form-item">
        <span>Owner's Liability</span>
        <el-form-item
          prop="owner_liability_ind">
          <v-radio-group
            v-model="formData.owner_liability_ind"
            :border="true"
            :list="yesNoOptions" />
        </el-form-item>
      </div>
      <div
        v-if="formData.owner_liability_ind == 1"
        class="form-item">
        <span>Sum Insured of Owner's Liability</span>
        <el-form-item
          prop="sum_owner_liability">
          <v-select
            v-model="formData.sum_owner_liability"
            :list="localAllOptions.owner_liability" />
        </el-form-item>
      </div> -->
      <template v-if="!isCoverageFire&&localAllOptions.benefits.length>0">
        <h3>More Benefits</h3>
        <div class="form-item">
          <v-checkbox-group
            v-model="formData.benefits"
            :isColumn="false"
            :list="localAllOptions.benefits" />
        </div>
      </template>

    </el-form>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import {mapState} from 'vuex'

export default {
  name: 'FormUnderwriting',
  mixins: [MixinOptions, MixinRules],
  props: {
    form: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    const checkSumOwner = (rule, value, callback) => {
      const valueResult = value !== null && value !== ''
      const { owner_liability_ind } = this.formData
      if(owner_liability_ind == 1 && !valueResult) {
        callback(new Error(this.$t('placeholder.input')))
      }
      callback()
    }
    const checkAreaNumber = (rule, value, callback) => {
      var reg = /^[1234567890]*$/
      if (value && !reg.test(value)) {
        callback( new Error( '最大輸入8位整數' ))
      } else {
        callback()
      }
    }
    return {
      formData: {
        // class_id: 26,
        // customer_id: '',
        prop_insured: '',
        bldg_typ: '',
        floor_area: '',
        coverage_id: '',
        prop_age: '',
        plan_tier: 0,
        bsc_sum_insured:'',
        // sum_owner_liability: '',
        // owner_liability_ind: '',
        benefits: []
      },
      extraRules: {
        sum_owner_liability: [
          { validator: checkSumOwner, trigger: ['change', 'blur'] }
        ],
        floor_area: [
          { validator: checkAreaNumber, trigger: ['change', 'blur'] }
        ],
      }
    }
  },
  computed: {
    ...mapState('errorfield', ['errorField']),
    localAllOptions() {
      return this.allOptions26
    },
    hasSumBuildingStructure() {
      const { coverage_id } = this.formData
      if([2, 3].includes(coverage_id)) {
        return true
      }
      return false
    },
    // 選擇了火險
    isCoverageFire() {
      const { coverage_id } = this.formData
      const data = this.getOptionData('', coverage_id, this.localAllOptions.coverage)
      const { id } = data || {}
      return id == 2
    }
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        Object.keys(this.formData).some(key => {
          if(key in val) {
            this.formData[key] = val[key]
          }
        })
      }
    },
    isCoverageFire: {
      immediate: true,
      handler(val) {
        if(val) {
          this.formData.benefits = []
        }
      }
    },
    errorField:{
      immediate:true,
      deep:true,
      handler(val){
        if(val)
        {
          this.errScrollToValidDom(val)

        }
      }
    }
  },
  methods: {
    submitForm() {
      // 表單校驗
      this.$refs.form.validate(valid => {
        if(valid) {
          let params = {
            ...this.formData
          }
          // if(this.formData.owner_liability_ind != 1) {
          //   delete params.sum_owner_liability
          // }
          this.$emit('getFormData', {
            ...params,
            class_id: 26
          })
        }
      })

    }
  }
}
</script>
<style lang="scss" scoped>
.form-underwriting {
  position: relative;
  // width: 700px;
}
</style>
